module.exports = __webpack_public_path__ + "img/info.033dc43f.svg";